const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const withBundleLoading = require("../hoc/withBundleLoading");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");

const AT = require("../vault/ActionTypes");
const OpsPage = require("../vault/OpsPage");
const OpsUser = require("../vault/OpsUser");
const {
	atCurrResult,
	atUserAssignedBlocks,
	atBlocks,
} = require("../vault/StateCursors");

const AssetsUtil = require("../util/AssetsUtil");
const Sounds = require("../util/Sounds");

const ChapterSection = require("../../../shared/ChapterSection");
const GradeChapter = require("../../../shared/GradeChapter");
const MiscBlockUtil = require("../../../shared/MiscBlockUtil");
const URLMake = require("../../../shared/URLMake");

const ArrowIcon = require("./ArrowIcon");
const AssignmentsList = require("./AssignmentsList");
const HomeworkIcon = require("./HomeworkIcon");
const ScrollArea = require("./ScrollArea");
const SequenceChapter = require("./SequenceChapter");
const StudentLink = require("./StudentLink");

const styles = require("./styles/SequenceSlideout.css");

// I think we need this part because it updates new stars obtained on blocks
// from the frontend.
const mergeUserBlocks = function(assignedBlocks, userBlocks) {
	_.each(assignedBlocks, ab => {
		const blockModel = _.get(userBlocks, [ab.blockID, "model"]) || {};
		const blockModelInfo = _.pick(blockModel, [
			"starsObtained",
			"starsObtainedAt",
			"starsObtainedAtTZ",
		]);

		if (blockModel) {
			_.extend(ab, blockModelInfo);
		}
	});
	return assignedBlocks;
};

const getPropsFromVault = (props, vaultState) => {
	const {user} = props;
	const pageDataDefault = {};
	if (_.get(user, "model")) {
		_.extend(pageDataDefault, _.get(user, "model.sequenceData"));
	}
	// Integer parsing done because test server returns some key value as string
	_.forEach(pageDataDefault, (value, key) => {
		pageDataDefault[key] = parseInt(value);
	});

	const userBlocks = atBlocks(vaultState).get() || {};
	const assignedBlocks = atUserAssignedBlocks(vaultState).get() || {};

	_.each(assignedBlocks, ab => {
		const chapterContext = GradeChapter.chapterIDToContext(ab.chapterID);
		ab.blockIndex = GradeChapter.toBlockIndex(ab.chapterID, ab.blockID);
		ab.chapterIndex = chapterContext.chapterIndex;
	});

	const result = atCurrResult(vaultState).get();
	const userAssignedBlocks = mergeUserBlocks(assignedBlocks, userBlocks);
	const isCurrent = blockModel =>
		OpsUser.getHomeworkDataForBlock(user, blockModel).isCurrentWeek;
	const [currentAssignedBlocks, pastAssignedBlocks] = _.partition(
		userAssignedBlocks,
		isCurrent
	);
	return {
		pageDataDefault,
		result,
		userAssignedBlocks,
		currentAssignedBlocks,
		pastAssignedBlocks,
	};
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withBundleLoading(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, getPropsFromVault);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "SequenceSlideout",

		propTypes: {
			// passed down from parent
			user: PT.object.isRequired,
			page: PT.object.isRequired,

			// Injected by HOCs
			userAssignedBlocks: PT.object,
			currentAssignedBlocks: PT.array,
			pastAssignedBlocks: PT.array,
			pageDataDefault: PT.object.isRequired,
			dispatch: PT.func.isRequired,
			result: PT.object,
			requireOrLoadBundle: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			closeSequenceSlideout: function() {
				this.setState({isSliderOpen: false});
			},
			openedModalOnPage: function() {
				this.setState({isSliderOpen: false});
			},
		},

		getInitialState: function() {
			return {
				isSliderOpen: false,
				...this.props.pageDataDefault,
			};
		},

		componentDidUpdate: function(prevProps) {
			const pageAttrs = ["name", "gradeNumber", "chapterIndex"];
			const prevPage = _.pick(prevProps.page, pageAttrs);
			const currPage = _.pick(this.props.page, pageAttrs);
			if (!_.isEqual(prevPage, currPage)) {
				// if the user navigates to a new page, sync the playlist to that page
				this.setState(this.props.pageDataDefault);
			}
		},

		clickHandler: function() {
			this.setState({isSliderOpen: false});
		},

		incrementChapter: function(forPrev) {
			const {gradeNumber, chapterIndex} = this.state;
			const newChapInfo = GradeChapter.getAdjacentChapter(
				gradeNumber,
				chapterIndex,
				forPrev
			);
			if (newChapInfo) this.setState(newChapInfo);
		},

		toggleSlider: function() {
			const {user, page, result} = this.props;
			if (
				OpsPage.isCurrentlyTakingTest(user, page) &&
				!OpsUser.hasKey(user, "trainer allow unfinished test")
			) {
				const messageType =
					result.resultType === "bookTest"
						? "finishBookTest"
						: "finishTestOrQuit";
				this.props.dispatch({
					type: AT.SHOW_CONFIRM,
					messageType,
					data: {
						onConfirmDispatch: {
							type: AT.SET_PAGE,
							pageState: URLMake.state.forOverview(this.props.result),
						},
						styleType: "grade" + page.gradeNumber,
					},
				});
				return;
			}

			const isOpen = !this.state.isSliderOpen;
			const clickSound = isOpen ? "arrow-right" : "arrow-left";
			Sounds.playSound(clickSound);
			this.setState({isSliderOpen: isOpen});
		},

		// This function forces content in parentheses to have no breaks,
		// this works for the simple chapter names with only one set of braces
		renderNonBreakingTitle: function(title) {
			let newTitle = title;
			newTitle = newTitle.replace(/\&/, "&amp;");
			newTitle = newTitle.replace(/\</, "&lt;");
			newTitle = newTitle.replace(/\>/, "&gt;");
			const parsed = /\((.+?)\)/.exec(newTitle);
			if (parsed) {
				const segment = parsed[1];
				const parsedSegment = segment.replace(/\s+/g, "&nbsp;");
				newTitle = newTitle.replace(segment, parsedSegment);
			}
			return {__html: newTitle};
		},

		renderSlideout: function(traySrc, icon, content, options = {}) {
			const {isTeacher} = options;
			const {isSliderOpen} = this.state;
			const mainClass = isSliderOpen ? styles.open : styles.closed;
			const backdropClass = isSliderOpen
				? styles.showBackdrop
				: styles.hideBackdrop;

			return (
				<div className={styles.topContainer}>
					<div className={backdropClass} onClick={this.toggleSlider} />
					<div
						className={mainClass + " " + (isTeacher ? styles.forTeacher : "")}
					>
						<div className={styles.trayContainer}>
							<img className={styles.trayImg} src={traySrc} />
							<div className={styles.toggle} onClick={this.toggleSlider}>
								{icon}
							</div>
							{content}
						</div>
					</div>
				</div>
			);
		},

		renderCurrentAssignments: function() {
			const {currentAssignedBlocks} = this.props;
			const finishedBlocks = MiscBlockUtil.getFinishedBlocks(
				currentAssignedBlocks
			);
			const unfinishedBlocks = MiscBlockUtil.getUnfinishedBlocks(
				currentAssignedBlocks
			);

			const currentBlocks = [
				...MiscBlockUtil.sortUnfinishedHomework(unfinishedBlocks),
				...MiscBlockUtil.sortFinishedHomework(finishedBlocks),
			];

			return this.renderTopAssignments(currentBlocks);
		},

		renderPastAssignments: function() {
			const {pastAssignedBlocks} = this.props;
			const finishedBlocks = MiscBlockUtil.getFinishedBlocks(
				pastAssignedBlocks
			);
			const unfinishedBlocks = MiscBlockUtil.getUnfinishedBlocks(
				pastAssignedBlocks
			);

			const pastBlocks = [
				...MiscBlockUtil.sortUnfinishedHomework(unfinishedBlocks),
				...MiscBlockUtil.sortFinishedHomework(finishedBlocks),
			];

			return this.renderBottomAssignments(pastBlocks);
		},

		// Helper for displaying assignments in the top area of the homework slideout.
		// These are "Current" assignments for Academy students, and "To Do" assignments for non-Academy.
		// @param {Array} blocks - the blocks to display
		// @param {string} title - the title of the top area. Either "To Do:", "Current:", or undefined (defaults to "Current:")
		renderTopAssignments: function(blocks, title = "Current:") {
			const {user, page} = this.props;

			// Show different copy for no assignments in area if this is a "To Do" area (non-Academy) or "Current" (Academy)
			const emptyText =
				title === "To Do:"
					? "No uncompleted assignments!"
					: "You have no current assignments.";

			let content;
			if (blocks.length === 0) {
				content = (
					<div className={styles.emptyCurrent}>
						<p className={styles.largerText}>{emptyText}</p>
					</div>
				);
			} else {
				content = (
					<AssignmentsList
						user={user}
						page={page}
						title={title}
						blocks={blocks}
						clickHandler={this.clickHandler}
					/>
				);
			}
			return content;
		},

		// Helper for displaying assignments in the bottom area of the homework slideout.
		// These are "Past" assignments for Academy students, and "Completed" assignments for non-Academy.
		// @param {Array} blocks - array of blocks to display
		// @param {string} title - title of the bottom area. Either "Past:", "Completed:", or undefined (defaults to "Past:")
		renderBottomAssignments: function(blocks, title = "Past:") {
			const {user, page} = this.props;

			// No more than 30 past/completed homework blocks are displayed
			const maxLength = 30;

			if (blocks.length === 0) {
				return null;
			} else if (blocks.length > maxLength) {
				blocks = blocks.slice(0, maxLength);
			}

			return (
				<>
					<AssignmentsList
						user={user}
						page={page}
						title={title}
						blocks={blocks}
						clickHandler={this.clickHandler}
					/>
					<div className={styles.homeworkLinkContainer}>
						<StudentLink
							className={styles.homeworkLink}
							to={URLMake.forProfile(user.userID, "homework")}
						>
							View All
						</StudentLink>
					</div>
				</>
			);
		},

		renderNonAcademyAssignments: function() {
			// For non-academy users, all assigned blocks are treated as "past",
			// so pastAssignedBlocks includes all assigned blocks.
			const {pastAssignedBlocks} = this.props;
			const finishedBlocks = MiscBlockUtil.getFinishedBlocks(
				pastAssignedBlocks
			);
			const unfinishedBlocks = MiscBlockUtil.getUnfinishedBlocks(
				pastAssignedBlocks
			);

			const completedBlocks = MiscBlockUtil.sortFinishedHomework(
				finishedBlocks
			);
			const todoBlocks = MiscBlockUtil.sortUnfinishedHomework(unfinishedBlocks);

			const completed = this.renderBottomAssignments(
				completedBlocks,
				"Completed:"
			);
			const todo = this.renderTopAssignments(todoBlocks, "To Do:");

			return {completed, todo};
		},

		renderHomeworkContent: function() {
			const {pageDataDefault, user} = this.props;
			const {gradeNumber} = pageDataDefault;
			const gradeStyle = styles[`grade-${gradeNumber}Color`];
			const isAcademy = OpsUser.isAcademyUser(user);

			// If this is a non-academy user,
			// then we use "To Do" instead of "Current" for the top area assignments,
			// and "Completed" instead of "Past" for the bottom area assignments.
			let top, bottom;
			if (isAcademy) {
				top = this.renderCurrentAssignments();
				bottom = this.renderPastAssignments();
			} else {
				const {completed, todo} = this.renderNonAcademyAssignments();
				top = todo;
				bottom = completed;
			}

			return (
				<div className={styles.contentContainer + " " + gradeStyle}>
					<div className={styles.title}>
						<HomeworkIcon
							disabled={true}
							colorStyle={gradeStyle}
							sizeOverride={styles.homeworkIcon}
							isAcademy={isAcademy}
							noTooltip={true}
						/>
						<div className={styles.titleText}>{"Homework"}</div>
					</div>
					<ScrollArea
						useWonkyCursor={true}
						hasXScroll={false}
						useGlobalHotkeysForY={true}
						useMouseMoveToScroll={true}
						areaClassName={styles.scrollArea}
						contentClassName={styles.content}
						yBarClassName={styles.yBar}
						yThumbClassName={styles.yThumb}
					>
						{top}
						{bottom}
					</ScrollArea>
				</div>
			);
		},

		renderPlaylist: function() {
			const {user, page} = this.props;
			const {gradeNumber, chapterIndex} = this.state;

			if (!_.isFinite(gradeNumber) || !_.isFinite(chapterIndex)) {
				return null;
			}

			const makeArrowIcon = ({direction, useFakeIcon}) => {
				const size = 1.5;
				if (useFakeIcon) {
					return <ArrowIcon type={"invisible"} size={size} />;
				} else {
					return (
						<ArrowIcon
							direction={direction}
							colorName={"grade-" + gradeNumber}
							type={"sharp"}
							size={size}
							useColorHoverEffect={true}
							preventScaleHover={true}
							useWonkyCursor={true}
						/>
					);
				}
			};

			const gradeStyle = styles[`grade-${gradeNumber}Color`];
			const hasPrevChapter = !!GradeChapter.getAdjacentChapter(
				gradeNumber,
				chapterIndex,
				true
			);
			const hasNextChapter = !!GradeChapter.getAdjacentChapter(
				gradeNumber,
				chapterIndex,
				false
			);
			const prevButton = makeArrowIcon({
				direction: "left",
				useFakeIcon: !hasPrevChapter,
			});
			const nextButton = makeArrowIcon({
				direction: "right",
				useFakeIcon: !hasNextChapter,
			});
			const chapterTitle = (
				<div
					className={styles["chapterTitleText"] + " " + gradeStyle}
					dangerouslySetInnerHTML={this.renderNonBreakingTitle(
						ChapterSection.getChapterNameFromContext({
							gradeNumber,
							chapterIndex,
						})
					)}
				/>
			);
			const chapterGradeImg = (
				<img
					className={styles.chapterImg}
					src={AssetsUtil.getImageForChapterInGrade(
						chapterIndex + 1,
						gradeNumber
					)}
				/>
			);

			const title = (
				<div className={styles.title}>
					<div
						className={styles.nav}
						onClick={() => this.incrementChapter(true)}
					>
						{prevButton}
					</div>
					{chapterGradeImg}
					{chapterTitle}
					<div
						className={styles.nav}
						onClick={() => this.incrementChapter(false)}
					>
						{nextButton}
					</div>
				</div>
			);

			return (
				<div className={styles.contentContainer}>
					{title}
					<SequenceChapter
						user={user}
						page={page}
						gradeNumber={gradeNumber}
						chapterIndex={chapterIndex}
						clickHandler={this.clickHandler}
					/>
				</div>
			);
		},

		shouldRenderForStudent: function() {
			const {user, page, requireOrLoadBundle} = this.props;
			const TrainerBundle = requireOrLoadBundle("trainer");
			const isStudent = OpsUser.isStudent(user);
			const isInTest =
				page.blockType === "test" && OpsPage.isCurrentlyTakingTest(user, page);

			return TrainerBundle && isStudent && !isInTest;
		},

		shouldRenderForStaff: function() {
			const {user, requireOrLoadBundle} = this.props;
			const TrainerBundle = requireOrLoadBundle("trainer");
			const isAoPS = OpsUser.hasAoPSRole(user);

			return TrainerBundle && isAoPS;
		},

		shouldRenderForTeacher: function() {
			const {user, requireOrLoadBundle} = this.props;
			const TrainerBundle = requireOrLoadBundle("trainer");
			const isTeacher = OpsUser.hasTeacherRole(user);

			return TrainerBundle && isTeacher;
		},

		renderForStudent: function() {
			const {user, userAssignedBlocks} = this.props;
			const isAcademy = OpsUser.isAcademyUser(user);
			const showHomework = isAcademy || !_.isEmpty(userAssignedBlocks); // all academy students and anyone with homework

			return showHomework
				? this.renderStudentHomework()
				: this.renderStudentPlaylist();
		},

		renderStudentHomework: function() {
			const {pageDataDefault, user} = this.props;
			const {gradeNumber} = pageDataDefault;
			const isAcademy = OpsUser.isAcademyUser(user);
			const traySrc = AssetsUtil.getTrayImageByGrade(
				"sequence-slider",
				gradeNumber
			);
			const icon = (
				<HomeworkIcon
					className={styles.icon}
					disabled={true}
					sizeOverride={styles.toggleIcon}
					secondaryColorStyle={styles[`grade-${gradeNumber}Color`]}
					isAcademy={isAcademy}
					noTooltip={true}
				/>
			);
			const content = this.renderHomeworkContent();
			return this.renderSlideout(traySrc, icon, content);
		},

		renderStudentPlaylist: function() {
			const {gradeNumber} = this.state;
			const traySrc = AssetsUtil.getTrayImageByGrade(
				"sequence-slider",
				gradeNumber
			);
			const icon = (
				<img
					className={styles.icon}
					src={AssetsUtil.getImageForGrade(gradeNumber, "white")}
				/>
			);
			const content = this.renderPlaylist();
			return this.renderSlideout(traySrc, icon, content);
		},

		renderForStaff: function() {
			return this.renderForTeacher();
		},

		renderForTeacher: function() {
			const traySrc = AssetsUtil.getTrayImageForTeacher("sequence-slider");
			const icon = (
				<img
					className={styles.icon}
					src={AssetsUtil.getTrainerIconButton("hamburger-teacher")}
				/>
			);
			const content = this.renderPlaylist();
			return this.renderSlideout(traySrc, icon, content, {isTeacher: true});
		},

		render: function() {
			const {page} = this.props;
			const {demo} = page;
			if (demo) return null;

			if (this.shouldRenderForStudent()) return this.renderForStudent();
			if (this.shouldRenderForStaff()) return this.renderForStaff();
			if (this.shouldRenderForTeacher()) return this.renderForTeacher();

			return null;
		},
	})
);
